export default __webpack_public_path__ + "static/media/travel.7bfd4786.webp";